import { Store } from './Store.js';
import { MockedStore } from './MockedStore.js';
export { RequestStatus, RoomStatus } from './Store.js';

function createStore() {
  // if (DEV) {
  //   return new MockedStore();
  // }
  return new Store();
}

const store = createStore();

window.addEventListener('popstate', () => {
  store.autoConnect();
});
store.init();

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    store.pingWakeLock();
  }
});

if (DEV) {
  window.store_ = store;
}

export default store;
